import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment';
var Cuenta_con_modComponent = /** @class */ (function () {
    function Cuenta_con_modComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            mod_aprob: new FormControl(''),
            numero: new FormControl(''),
            fecha: new FormControl({ value: '', disabled: true })
        });
        if (!JSON.parse(localStorage.getItem("cuenta_con_mod"))) {
            localStorage.setItem("cuenta_con_mod", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("cuenta_con_mod"));
            this.form.controls['mod_aprob'].setValue(this.rows[0] ? this.rows[0].mod_aprob : 'NO');
            this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '');
            this.form.controls['fecha'].setValue(this.rows[0] ? this.rows[0].fecha : null);
        }
        this.cuenta_con_mod = { mod_aprob: '', numero: '', fecha: null };
    }
    Cuenta_con_modComponent.prototype.add_cuenta_con_mod = function (event, type) {
        if (event) {
            this.fecha = moment(event.value).format('DD/MM/YYYY');
        }
        else {
            var temp = JSON.parse(localStorage.getItem("cuenta_con_mod"));
            if (temp > 0) {
                this.fecha = temp[0].fecha;
            }
        }
        localStorage.setItem("cuenta_con_mod", JSON.stringify([]));
        this.actualRow = localStorage.getItem("cuenta_con_mod");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            mod_aprob: this.form.value.mod_aprob,
            numero: this.form.value.numero,
            fecha: this.fecha
        });
        localStorage.setItem("cuenta_con_mod", JSON.stringify(this.rows));
    };
    Cuenta_con_modComponent.prototype.delete_cuenta_con_mod = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("cuenta_con_mod", JSON.stringify(this.rows));
            }
        }
    };
    return Cuenta_con_modComponent;
}());
export { Cuenta_con_modComponent };
